import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const AnalysisApi = ApiCore(globalDomains.ANALYSIS_AFREECATV);
export default AnalysisApi;
